import { defaultRulePictogram, defaultFilterRulesPictogramsSga } from "./state";

/**
 * Mutación que lista las reglas de los pictogramas de SGA.
 *
 * @param {*} state.rulesPictogramsSga - Estado de las reglas de pictogramas de SGA.
 * @param rulesPictogramsSga - Reglas de pictogramas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setRulesPictogramsSga(state, rulesPictogramsSga) {
    state.rulesPictogramsSga = rulesPictogramsSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionRulePictogramSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la regla del pictograma por defecto.
 *
 * @param {*} state.rulePictogram - Estado de la regla del pictograma.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultRulePictogramSga(state) {
    state.rulePictogram = defaultRulePictogram();
}

/**
 * Mutación que establece el filtro de las reglas de pictogramas de SGA por defecto.
 *
 * @param {*} state.filterRulesPictogramsSga - Estado del filtro de reglaas de pictogramas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterRulesPictogramsSga(state) {
    state.filterRulesPictogramsSga = defaultFilterRulesPictogramsSga();
}

/**
 * Mutación que establece la cantidad de reglas de pictogramas por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filterRulesPictogramsSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterRulesPictogramsSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterRulesPictogramsSga = {
        ...state.filterRulesPictogramsSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterRulesPictogramsSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterRulesPictogramsSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de reglas de pictogramas.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterRulesPictogramsSga.page - Página actual.
 * @param {*} state.filterRulesPictogramsSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterRulesPictogramsSga.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateRulesPictogramsSga(state, paginate) {
    state.filterRulesPictogramsSga = {
        ...state.filterRulesPictogramsSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la regla del pictograma de SGA.
 *
 * @param {*} state.rulePictogram - Estado de la regla del pictograma.
 * @param rulePictogram - Regla pictograma de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setRulePictogramSga(state, rulePictogram) {
    state.rulePictogram = {
        id: rulePictogram.id,
        name: rulePictogram.name,
        sga_pictogram_combination_ids:
            rulePictogram.sga_pictogram_combination_ids,
        sga_pictograms_to_display_ids:
            rulePictogram.sga_pictograms_to_display_ids,
    };
}
